var exports = {
  "xL": "ChannelIndexPage.module__voiceChannelContainer___cXFjYT",
  "jn": "ChannelIndexPage.module__voiceChannelFullscreenShell___cXFjYT",
  "Ku": "ChannelIndexPage.module__channelGrid___cXFjYT",
  "Uv": "ChannelIndexPage.module__channelGridVoiceCallActive___cXFjYT",
  "F5": "ChannelIndexPage.module__channelGridVoiceCallExpanded___cXFjYT",
  "DM": "ChannelIndexPage.module__channelGridVoiceChatSide___cXFjYT",
  "wS": "ChannelIndexPage.module__contentGrid___cXFjYT",
  "tD": "ChannelIndexPage.module__channelGridVoiceChatWithSidePanel___cXFjYT",
  "cx": "ChannelIndexPage.module__channelGridVoiceChatHidden___cXFjYT",
  "cg": "ChannelIndexPage.module__chatAreaSlot___cXFjYT",
  "hO": "ChannelIndexPage.module__voiceActiveHeaderWrapper___cXFjYT",
  "$A": "ChannelIndexPage.module__voiceActiveHeaderWrapperOverlay___cXFjYT",
  "QH": "ChannelIndexPage.module__voiceActiveHeaderWrapperExpanded___cXFjYT",
  "Hz": "ChannelIndexPage.module__compactCallWrapper___cXFjYT",
  "Gi": "ChannelIndexPage.module__compactCallWrapperExpanded___cXFjYT",
  "_p": "ChannelIndexPage.module__compactCallWrapperResizing___cXFjYT",
  "rF": "ChannelIndexPage.module__compactVoiceCallView___cXFjYT",
  "ac": "ChannelIndexPage.module__compactVoiceCallViewExpanded___cXFjYT",
  "ec": "ChannelIndexPage.module__memberListDivider___cXFjYT",
  "ly": "ChannelIndexPage.module__searchPanel___cXFjYT",
  "hh": "ChannelIndexPage.module__voiceJoinEmptyState___cXFjYT",
  "HM": "ChannelIndexPage.module__voiceJoinEmptyContent___cXFjYT",
  "bo": "ChannelIndexPage.module__voiceJoinEmptyMark___cXFjYT",
  "NJ": "ChannelIndexPage.module__voiceJoinEmptyIcon___cXFjYT",
  "m2": "ChannelIndexPage.module__voiceJoinEmptyTitle___cXFjYT",
  "F0": "ChannelIndexPage.module__voiceJoinDisabledWrap___cXFjYT",
};

module.exports = exports;
